// import R from 'ramda';
import {
  ACTIVATION_START,
  ACTIVATION_SUCCESS,
  ACTIVATION_ERROR,
  ACTIVATION_PASSWORD_START,
  ACTIVATION_PASSWORD_ERROR,
  ACTIVATION_FINISH,
} from '../actions';

import initialState from './initialState';

function activation(state = initialState.activation, action) {
  switch (action.type) {
    case ACTIVATION_START:
      return Object.assign({}, state, {
        isFetchingActivation: true,
        token: action.token,
        user: null,
        isValid: false,
        err: null,
      });
    case ACTIVATION_SUCCESS:
      return Object.assign({}, state, {
        isFetchingActivation: false,
        token: action.token,
        user: {
          firstName: action.data.first_name,
          lastName: action.data.last_name,
        },
        isValid: true,
        err: null,
      });
    case ACTIVATION_ERROR:
      return Object.assign({}, state, {
        isFetchingActivation: false,
        token: action.token,
        isValid: false,
        user: null,
        err: action.err,
      });
    case ACTIVATION_PASSWORD_START:
      return Object.assign({}, state, {
        isFetchingActivation: true,
        password: action.password,
        password_confirmation: action.password_confirmation,
        token: action.token,
        errorPassword: null,
      });
    case ACTIVATION_PASSWORD_ERROR:
      return Object.assign({}, state, {
        errorPassword: action.errorPassword,
        isFetchingActivation: false,
      });
    case ACTIVATION_FINISH:
      return Object.assign({}, state, {
        isFetchingActivation: false,
        isActivated: true,
        errorPassword: null,
      });
    default:
      return state;
  }
}


export default activation;
